import FormClientImg from "./Form/FormClientImg"
import api from '../../utils/api'
import { useState } from 'react'
/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function NewClientImg({clientId, handleSubmit ,  handleOnSuccess, btCancelAction}) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerClientImg(obj) {
        let paramsName = "empty"
        let msgType = 'success'
        //check if accessory exists
        if (obj.imgName) {
            paramsName = obj.imgName
        }

        const formData = new FormData()
        await Object.keys(obj).forEach((key) => formData.append(key, obj[key]))


        const data = await api.post(`/clientImg/new/${paramsName}`, formData, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        handleSubmit(msgType)
        if(msgType !== 'error'){
            handleOnSuccess()
        }
            
       




    }

    return (
        <FormClientImg title="Nova Imagem de Referência" handleSubmit={registerClientImg} clientId={clientId} btCancelAction={btCancelAction} />
    )
}

export default NewClientImg